import { Children } from 'react';
import type { ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export interface PanelProps {
  /** Показывать скелетон вместо контента. */
  loading?: boolean;
  header?: ReactNode;
  headerClassName?: string;
  className?: string;
  /** Используется только для dom-id панели. */
  eventKey?: string;
  children?: ReactNode;
}

const Panel = (props: PanelProps) => {
  const {
    loading,
    header,
    headerClassName,
    className,
    eventKey,
    children,
  } = props;

  const panelSkeleton = Children.map(children, (_child, idx) => {
    return (
      <Row key={ `panel-skeleton-${ idx }` } style={ { fontSize: 30, lineHeight: 2 } }>
        <Col className='col-md-4'><Skeleton /></Col>
        <Col className='col-md-4'><Skeleton /></Col>
        <Col className='col-md-4'><Skeleton /></Col>
      </Row>
    );
  });

  return (
    <Card id={ `panel-${ eventKey }` } className={ className ? `mb-2 ${ className }` : 'mb-2' }>
      { header && (
        <Card.Header className={ headerClassName }>
          { header }
        </Card.Header>
      ) }

      <Card.Body>
        { loading ? panelSkeleton : children }
      </Card.Body>
    </Card>
  );
};

export default Panel;
